/**
 * Active-offer consent text — character-for-character per tech spec §Consent
 * sheets (scenario 1131).
 */
export function ACTIVE_CONSENT_TEXT(agentName: string): string {
  return `Accepting shares your name and contact info with ${agentName}. Your financial details stay at the level you've already published (brackets — you can share more later in Settings).`;
}

/**
 * Active-offer other-offers note — character-for-character per tech spec.
 * Must match this string exactly.
 */
export const ACTIVE_OTHER_OFFERS_NOTE =
  "Your other offers stay open until this connection is confirmed.";

/**
 * Standing-offer outcome line — character-for-character per tech spec §Consent
 * sheets (scenario 1132). "{Agent}" is the literal agent display name.
 */
export function STANDING_OUTCOME_LINE(agentName: string): string {
  return `${agentName} confirms new connections before they start — usually within a day. Nothing is shared until they do.`;
}

/** M8-D own-agent acceptance copy, pinned to the Board 5 formalization flow. */
export function OWN_AGENT_FORMALIZATION_TITLE(agentName: string): string {
  return `Formalize with ${agentName}`;
}

export const OWN_AGENT_FORMALIZATION_TEXT =
  "You're already working together — this just locks your agreed credits to your closing. Nothing else changes.";
